var _path, _path2, _path3, _path4, _circle, _path5, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181A93",
    d: "M17.3 0h478.4v342H17.3V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA44A",
    d: "M0 0h513v114H0V0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A9F0B",
    d: "M0 228h513v114H0V228z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 114h513v114H0V114z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 256.5,
    cy: 171,
    r: 34.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#181A93",
    d: "M256.5 216.6c-25.1 0-45.6-20.5-45.6-45.6s20.5-45.6 45.6-45.6 45.6 20.5 45.6 45.6-20.5 45.6-45.6 45.6zm0-11.4c18.2 0 34.2-16 34.2-34.2s-15.9-34.2-34.2-34.2-34.2 16-34.2 34.2 16 34.2 34.2 34.2z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#181A93",
    cx: 256.5,
    cy: 171,
    r: 22.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/IN.30502647.svg";
export { ForwardRef as ReactComponent };